<script setup lang="ts">
import Select from 'primevue/select';
import type { PolicyVisibilityFilter, PolicyProductionFilter } from '@/types/versioning';

/**
 * The two filters every policy list shares (KYX, KYT, Pulse and their templates): soft-deleted
 * visibility and production (on/off). Options are defined once here so the lists can't drift.
 * Emits `change` after either filter changes, once the v-model has updated.
 */
const visibility = defineModel<PolicyVisibilityFilter>('visibility', { required: true });
const production = defineModel<PolicyProductionFilter>('production', { required: true });

const emit = defineEmits<{ change: [] }>();

const VISIBILITY_OPTIONS: { label: string; value: PolicyVisibilityFilter }[] = [
    { label: 'Não excluídas', value: 'active' },
    { label: 'Excluídas', value: 'deleted' },
    { label: 'Todas', value: 'all' },
];

const PRODUCTION_OPTIONS: { label: string; value: PolicyProductionFilter }[] = [
    { label: 'Todas', value: 'all' },
    { label: 'Em produção', value: 'in_production' },
    { label: 'Fora de produção', value: 'out_of_production' },
];
</script>

<template>
    <div class="flex items-center gap-4">
        <div class="flex items-center gap-2">
            <label class="text-sm font-normal text-gray-500">Exibir</label>
            <Select
                v-model="visibility"
                :options="VISIBILITY_OPTIONS"
                optionLabel="label"
                optionValue="value"
                @change="emit('change')"
            />
        </div>
        <div class="flex items-center gap-2">
            <label class="text-sm font-normal text-gray-500">Produção</label>
            <Select
                v-model="production"
                :options="PRODUCTION_OPTIONS"
                optionLabel="label"
                optionValue="value"
                @change="emit('change')"
            />
        </div>
    </div>
</template>
